"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRevenueSourceRank = exports.RevenueSource = void 0;
var RevenueSource;
(function (RevenueSource) {
    RevenueSource["QUICKBOOKS_OR_XERO"] = "QUICKBOOKS/XERO";
    RevenueSource["SELF_REPORTED"] = "SELF_REPORTED";
    RevenueSource["RETOOL"] = "RETOOL";
})(RevenueSource || (exports.RevenueSource = RevenueSource = {}));
/**
 *
 * When a company has duplicate prior-year-revenue entries for the same tax year
 * (e.g. one from QuickBooks and one self-reported), we deduplicate to one per year.
 * If createdAt timestamps are identical (common in copyCompany), this priority
 * determines the winner: user-provided data beats automated imports.
 * Lower index = higher priority. Update when adding new RevenueSource values.
 */
const REVENUE_SOURCE_PRIORITY = [
    RevenueSource.SELF_REPORTED,
    RevenueSource.QUICKBOOKS_OR_XERO,
    RevenueSource.RETOOL,
];
const getRevenueSourceRank = (source) => {
    const index = REVENUE_SOURCE_PRIORITY.indexOf(source);
    return index === -1 ? Infinity : index;
};
exports.getRevenueSourceRank = getRevenueSourceRank;
